import React, { useEffect, useState } from 'react';
import { Button, Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';

const BubbleClose = (props: any) => {
  const { onClose, content, children, ...rest } = props;

  return (
    <Bubble
      dark
      placement="bottom-end"
      escapeWithReference={true}
      content={
        <div className="dbi-following-page-header">
          {content}
          <i className="dbi-icon-close">
            <SvgIcon type="clonse" />
          </i>
        </div>
      }
      onClick={() => {
        if (onClose instanceof Function) {
          onClose();
        }
      }}
      {...rest}
    >
      {children}
    </Bubble>
  );
};

export default BubbleClose;
